import { useContext, useMemo } from "react";
import { AppConfigContext } from "../context";
import { AssetConfig } from "./assets";

export const useAssetConfigs = (): Record<string, AssetConfig> => {
  const {
    solVrtMintAddress,
    jitoSolMintAddress,
    jtoMintAddress,
    jtoVrtMintAddress,
    jtoVaultAddress,
    jtoVaultPaused,
    solVaultAddress,
    solVaultPaused,
    solVaultMaxCap,
    kyrosMintAddress,
    kyrosVrtMintAddress,
    kyrosVaultAddress,
    kyrosVaultPaused,
  } = useContext(AppConfigContext);

  return useMemo(
    () => ({
      sol: {
        id: "sol",
        underlyingLabel: "SOL",
        vrtName: "kySOL",
        mintAddress: jitoSolMintAddress,
        vrtMintAddress: solVrtMintAddress,
        vaultAddress: solVaultAddress,
        vaultPaused: solVaultPaused,
        vaultMaxCap: solVaultMaxCap,
        mintImage: "/jitosol.png",
        vrtImage: "/kysol.svg",
        headerImage: "/kySOLLogo.svg",
        restakeDescription:
          "kySOL combines staking, MEV, and TipRouter rewards into one token for optimized returns.",
        marketingDescription:
          "Three layers of yield in one token: SOL staking, MEV from Jito, and TipRouter rewards on top.",
        unstakeDescription:
          "Your kySOL will be converted to JitoSOL. You will need to wait at least for two full epochs (up to 6 days) before being able to claim your JitoSOL.",
        restakeStrategy: "sol",
      },
      jto: {
        id: "jto",
        underlyingLabel: "JTO",
        vrtName: "kyJTO",
        mintAddress: jtoMintAddress,
        vrtMintAddress: jtoVrtMintAddress,
        vaultAddress: jtoVaultAddress,
        vaultPaused: jtoVaultPaused,
        mintImage: "/jto.svg",
        vrtImage: "/kyjto.svg",
        headerImage: "/kyjto.svg",
        restakeDescription:
          "Stake your JTO to benefit from its only source of yield: TipRouter rewards.",
        marketingDescription:
          "Stake your JTO to benefit from its only source of yield: TipRouter rewards.",
        unstakeDescription:
          "Your kyJTO will be converted to JTO. You will need to wait at least for two full epochs (up to 6 days) before being able to claim your JTO.",
        restakeStrategy: "simple",
      },
      kyros: {
        id: "kyros",
        underlyingLabel: "KYROS",
        vrtName: "kyKYROS",
        mintAddress: kyrosMintAddress,
        vrtMintAddress: kyrosVrtMintAddress,
        vaultAddress: kyrosVaultAddress,
        vaultPaused: kyrosVaultPaused,
        mintImage: "/kyros.svg",
        vrtImage: "/kykyros.svg",
        headerImage: "/kykyros.svg",
        restakeDescription:
          "kyKYROS is the staked version of KYROS. It earns yield from protocol revenues and allows its holders to participate in the governance.",
        marketingDescription:
          "Earn protocol revenue and participate in Kyros governance through the staked KYROS token.",
        unstakeDescription:
          "Your kyKYROS will be converted to KYROS. You will need to wait at least for two full epochs (up to 6 days) before being able to claim your KYROS.",
        restakeStrategy: "simple",
      },
    }),
    [
      solVrtMintAddress,
      jitoSolMintAddress,
      jtoMintAddress,
      jtoVrtMintAddress,
      jtoVaultAddress,
      jtoVaultPaused,
      solVaultAddress,
      solVaultPaused,
      solVaultMaxCap,
      kyrosMintAddress,
      kyrosVrtMintAddress,
      kyrosVaultAddress,
      kyrosVaultPaused,
    ]
  );
};
